﻿import { FulfillmentLookup } from 'pages/orders/fulfillment_manager/components/FulfillmentLookup/FulfillmentLookup';
import { AddDeliverables } from 'pages/orders/fulfillment_manager/components/AddDeliverables/AddDeliverables';
import { FulfillmentView } from 'pages/orders/fulfillment_manager/components/FulfillmentView/FulfillmentView';
import { AddFulfillment } from 'pages/orders/fulfillment_manager/components/AddFulfillment/AddFulfillment';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { helpContent } from 'pages/orders/fulfillment_manager/help';
import { Api } from 'pages/orders/fulfillment_manager/Api';
import { FormattedMessage, useIntl } from 'react-intl';
import { PageHeader } from 'components/layout/page';
import { DefaultLayout } from 'components/layout';
import { Deliverable, Fulfillment } from 'types';
import { KendoIntlProvider } from 'app/culture';
import { useSuperState } from 'hooks';
import { useApp } from 'app';

import 'pages/orders/fulfillment_manager/styles/main.scss';
import 'styles/global-styles.scss';
import 'styles/kendo-default-theme-with-overrides.scss';

export const FulfillmentManager = () => {

    const [state, setState] = useSuperState({
        currentFulfillment: null as Fulfillment,
        fulfillmentLoading: false,
        fulfillments: [] as Fulfillment[],
        modalContents: 'viewFulfillment' as 'viewFulfillment' | 'addFulfillment' | 'addDeliverables',
        modalOpen: false
    });
    const { currentFulfillment, fulfillmentLoading, fulfillments, modalContents, modalOpen } = state;

    const { userId } = useApp();
    const { formatMessage, locale } = useIntl();

    const setModalOpen = (modalOpen: typeof state['modalOpen']) => setState({ modalOpen });

    const setCurrentFulfillment = (currentFulfillment: typeof state['currentFulfillment']) => setState({ currentFulfillment });

    const setFulfillments = (fulfillments: typeof state['fulfillments']) => setState({ fulfillments });

    const setModalContents = (modalContents: typeof state['modalContents']) => setState({ modalContents });

    const setFulfillmentLoading = (fulfillmentLoading: typeof state['fulfillmentLoading']) => setState({ fulfillmentLoading });

    const updateFulfillment = (updatedFulfillment: Fulfillment) => {

        const newFulfillments = state.fulfillments.map(fulfillment => fulfillment.ExternalId === updatedFulfillment.ExternalId ? updatedFulfillment : fulfillment);

        setFulfillments(newFulfillments);
        setCurrentFulfillment(updatedFulfillment);

    };

    const onAddDeliverablesClick = async (deliverablesToAdd: Deliverable[]) => {

        if (currentFulfillment) {

            setModalContents('viewFulfillment');
            setFulfillmentLoading(true);

            try {

                await Api.AddDeliverablesToFulfillment(
                    currentFulfillment.ExternalId,
                    userId,
                    deliverablesToAdd.map(deliverable => deliverable.Id)
                );
                const newDeliverables = [
                    ...deliverablesToAdd,
                    ...(currentFulfillment.Deliverables || [])
                ];

                updateFulfillment({
                    ...currentFulfillment,
                    Count: newDeliverables.length,
                    Deliverables: newDeliverables
                });

                setFulfillmentLoading(false);

            } catch {

                setFulfillmentLoading(false);

            }

        }

    };

    const ModalContents = () => {

        switch (modalContents) {

            case 'addFulfillment':
                return (
                    <AddFulfillment
                        onAddCompletion={newFufillment => {

                            setFulfillments([
                                newFufillment,
                                ...fulfillments
                            ]);
                            setCurrentFulfillment(newFufillment);
                            setModalContents('viewFulfillment');

                        }}
                        modalOpen={modalOpen}
                        onCancelClick={() => setModalOpen(false)}
                        setModalOpen={setModalOpen}
                    />
                );
            case 'viewFulfillment':
                return (
                    <FulfillmentView
                        fulfillment={currentFulfillment}
                        modalOpen={modalOpen}
                        onAddItemClick={() => setModalContents('addDeliverables')}
                        setCurrentFulfillment={setCurrentFulfillment}
                        setModalOpen={setModalOpen} shouldBeLoading={fulfillmentLoading}
                        updateFulfillment={updateFulfillment}
                    />
                );
            case 'addDeliverables':
                return (
                    <AddDeliverables
                        updateFulfillment={newFulfillment => {

                            updateFulfillment(newFulfillment);
                            setModalContents('viewFulfillment');

                        }}
                        deliverableTypeId={currentFulfillment?.DeliverableTypeId}
                        fulfillment={currentFulfillment}
                        modalOpen={modalOpen}
                        onAddClick={onAddDeliverablesClick}
                        onCancelClick={() => setModalContents('viewFulfillment')}
                        setModalOpen={setModalOpen}
                    />
                );

        }

    };

    const handleAddFullfillment = () => {

        setModalContents('addFulfillment');
        setModalOpen(true);

    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'fulfillment_manager.15a3ce36', defaultMessage: 'Fulfillment Manager' })}>
            <KendoIntlProvider>
                <LocalizationProvider language={locale}>
                    <IntlProvider locale={locale}>
                        <div className="fulfillments d-flex flex-column gap-3">

                            <PageHeader
                                cta={{
                                    label: (
                                        <div className={'d-inline-flex align-items-center gap-1'}>
                                            <i className={'fa-solid fa-plus'} />
                                            <span>
                                                <FormattedMessage defaultMessage="Add Code" id="add_code.e30e1bbf" />
                                            </span>
                                        </div>
                                    ),
                                    onClick: handleAddFullfillment
                                }}
                                helpContent={helpContent}
                                title={formatMessage({ id: 'fulfillment_code_lookup.d46f71e3', defaultMessage: 'Fulfillment Code Lookup' })}
                            />

                            <FulfillmentLookup
                                onFulfillmentClick={fulfillment => {

                                    setModalOpen(true);
                                    setCurrentFulfillment(fulfillment);
                                    setModalContents('viewFulfillment');

                                }}
                                fulfillments={fulfillments}
                                setFulfillments={setFulfillments}
                            />
                            <ModalContents />
                        </div>
                    </IntlProvider>
                </LocalizationProvider>
            </KendoIntlProvider>
        </DefaultLayout>
    );

};